import { useEffect, useState } from 'react';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { isApprovedAccessNote } from '../constants/venueAccessibility';

/**
 * REQ-104: approved accessibility cone notes for one venue (`venue_spec_flags`, read only).
 * Equality filters only (served by single-field indexes, no composite index), and only approved
 * accessibility notes are fetched, so pending notes and submitter emails never reach the browser.
 */
export function useApprovedAccessibilityNotes(venueId) {
  const [notes, setNotes] = useState([]);
  useEffect(() => {
    setNotes([]);
    if (!venueId) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDocs(query(
          collection(getFirestore(), 'venue_spec_flags'),
          where('venueId', '==', String(venueId)),
          where('category', '==', 'accessibility'),
          where('status', '==', 'approved'),
        ));
        if (cancelled) return;
        setNotes(snap.docs.map((d) => ({ id: d.id, ...d.data() })).filter(isApprovedAccessNote));
      } catch (err) {
        console.warn('Accessibility notes could not load:', err?.message || err);
      }
    })();
    return () => { cancelled = true; };
  }, [venueId]);
  return notes;
}

export default useApprovedAccessibilityNotes;
